import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts';
import { AICFChartComponent } from './aicfchart.component';
import { CYRChartComponent } from './cyrchart.component';
import { PGFChartComponent } from './pgfchart.component';
import { ARChartComponent } from './archart.component';
import { CFCYChartComponent } from './cfcychart.component';
import { CFRollingChartComponent } from './cfrollingchart.component';
import { PortfolioAllocationComponent } from './PortfolioAllocation.component';
import { NWMChartSettings, NWMBarChartSettings } from './NWMChartSettings';
import { SharedModule } from "app/modules/shared/shared.module"; // using minusSignToParens in PortfolioAllocation
import { NWMDoughnutChartComponent } from "app/components/NWMCharts/nwmdoughnutchart.component";

export type tooltipType = {
  visible: boolean;
  rows: {
    key: string;
    value: string;
    class?: string;
  }[];
};

@NgModule({
    imports: [
        BaseChartDirective,
        RouterModule,
        SharedModule.forRoot(),
        CYRChartComponent,
        PGFChartComponent,
        NWMDoughnutChartComponent,
        ARChartComponent,
        CFCYChartComponent,
        CFRollingChartComponent,
        AICFChartComponent,
        PortfolioAllocationComponent
    ],
    providers: [
        NWMChartSettings,
        NWMBarChartSettings,
    ],
    exports: [
        CYRChartComponent,
        PGFChartComponent,
        NWMDoughnutChartComponent,
        ARChartComponent,
        CFCYChartComponent,
        CFRollingChartComponent,
        AICFChartComponent,
        PortfolioAllocationComponent
    ]
})
export class NWMCharts { }
